import { productsA } from "./products-a";
import { productsB } from "./products-b";
import { productsC } from "./products-c";

export const PRODUCTS = [...productsA, ...productsB, ...productsC];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);
